<template>
  <section class='section-base'>
    <div class='section-base__title-box'>
      <div class='section-base__title'>Частые вопросы</div>
    </div>


    <div class='section'>
      <div class='title'>О получении услуг:</div>
      <v-expansion-panels class='panels'>
        <v-expansion-panel class='panel-item'>
          <v-expansion-panel-header class='header'>
            Как отправить заявление через портал?
          </v-expansion-panel-header>
          <v-expansion-panel-content class='content'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
            ex ea commodo consequat.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-expansion-panels class='panels'>
        <v-expansion-panel class='panel-item'>
          <v-expansion-panel-header class='header'>
            Как оставить электронную подпись?
          </v-expansion-panel-header>
          <v-expansion-panel-content class='content'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
            ex ea commodo consequat.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-expansion-panels class='panels'>
        <v-expansion-panel class='panel-item'>
          <v-expansion-panel-header class='header'>
            Сколько ожидать подтверждения оплаты?
          </v-expansion-panel-header>
          <v-expansion-panel-content class='content'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
            ex ea commodo consequat.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div class='section'>
      <div class='title'>Об оплате:</div>
      <v-expansion-panels class='panels'>
        <v-expansion-panel class='panel-item'>
          <v-expansion-panel-header class='header'>
            Как отправить квитанцию об оплате?
          </v-expansion-panel-header>
          <v-expansion-panel-content class='content'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
            ex ea commodo consequat.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-expansion-panels class='panels'>
        <v-expansion-panel class='panel-item'>
          <v-expansion-panel-header class='header'>
            Можно ли оплатить через портал?
          </v-expansion-panel-header>
          <v-expansion-panel-content class='content'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
            ex ea commodo consequat.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div class='section'>
      <div class='title'>Как работать с порталом?</div>
      <v-expansion-panels class='panels'>
        <v-expansion-panel class='panel-item'>
          <v-expansion-panel-header class='header'>
            Как войти в портал?
          </v-expansion-panel-header>
          <v-expansion-panel-content class='content'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
            ex ea commodo consequat.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-expansion-panels class='panels'>
        <v-expansion-panel class='panel-item'>
          <v-expansion-panel-header class='header'>
            Зачем нужен личный кабинет?
          </v-expansion-panel-header>
          <v-expansion-panel-content class='content'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
            ex ea commodo consequat.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FAQ'
};
</script>

<style scoped lang='scss'>
.panels {
  & .panel-item {
    padding-left: 0;
    padding-right: 0;

    &::before {
      box-shadow: none !important;
    }
    &::v-deep .v-expansion-panel-header__icon {
      display: none!important;
    }
  }

  & .header {
    color: $color-base;
    font-size: $font-size-base !important;
    padding-left: 0;
    padding-right: 0;
    width: auto;
  }

  & .content {

    &::v-deep .v-expansion-panel-content__wrap {
      padding-left: 0;
      padding-right: 0;
    }
  }
}

.section {
  margin-bottom: 20px;

  & .title {
    margin-bottom: 10px;
    font-size: $font-size-middle-level-1!important;
  }
}
</style>
